import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { GTM_ID } from './constants';
import { GlobalErrorInterceptorService } from './modules/main/interceptors/global-error-interceptor';
import { MainAppModule } from './modules/main/main.module';
import { environment } from '.././environments/environment';
import { SampleAppModule } from './modules/sample-app/sample-app.module';
import { NgxHotjarModule } from 'ngx-hotjar';
import { CategoryService } from './modules/main/services/categories.service';
import { BreadcrumbsService } from './modules/main/services/breadcrumbs.service';
import { CitiesService } from './modules/main/services/cities.service';
import { StatisticsService } from './modules/main/services/statistics.service';
import { createErrorHandler } from '@sentry/angular';

let hotJarContainer: Array<ModuleWithProviders<any>> = [];

if (environment.production) {
  hotJarContainer.push(NgxHotjarModule.forRoot('3157057'));
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    SampleAppModule,
    MainAppModule,
    ...hotJarContainer,
  ],
  providers: [
    CategoryService,
    BreadcrumbsService,
    CitiesService,
    StatisticsService,
    { provide: 'googleTagManagerId', useValue: GTM_ID },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalErrorInterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
